import { Typography } from "@hellocarbo/lasagne";
import { Trans, useTranslation } from "react-i18next";

type ReductionBlockProps = {
  title: string;
  percentage: number;
};

function ReductionBlock({ title, percentage }: ReductionBlockProps) {
  const { t } = useTranslation(["formatter", "trajectory"]);

  return (
    <div>
      <Typography as="h4" weight="bold" className="mb-3xs">
        {title}
      </Typography>
      <Typography step="-1" className="text-grayscale">
        <Trans
          t={t}
          i18nKey="trajectory:trajectory.reductions.reductionText"
          values={{
            percentage: t("formatter:percentage", { value: percentage }),
          }}
          components={{
            1: (
              <Typography
                step="-1"
                as="span"
                weight="bold"
                className="text-positive"
              />
            ),
          }}
        />
      </Typography>
    </div>
  );
}

export default ReductionBlock;
